import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs.ts';

export const CogniteDescribableModel = z.object({
  ...InstanceIdType.shape,

  name: z.string().optional().describe('Name of the instance'),
  description: z.string().optional().describe('Description of the instance'),
  tags: z.string().array().optional().describe('Text based labels for generic use, limited to 1000'),
  aliases: z.string().array().optional().describe('Alternative names for the node'),
});

/** @public */
export type CogniteDescribableModelInput = z.input<typeof CogniteDescribableModel>;
/** @public */
export type CogniteDescribableModelOutput = z.output<typeof CogniteDescribableModel>;
